import Immutable from 'immutable';

const UTILS = 'utils';
const PERSISTENT_STATE = 'persistentState';

const initialState = Immutable.fromJS({
    [PERSISTENT_STATE]: false,
});

export default function utils(state = initialState, action) {
    switch (action.type) {
        case 'PERSISTENT_STATE_LOADED':
            return state.setIn([PERSISTENT_STATE], action.payload);
        default:
            return state;
    }
}

export const persistentStateLoadedSelector = (state) => {
    return state.getIn([UTILS, PERSISTENT_STATE], false);
};
